import { SportsEvent } from '../types';

// NFL Team Colors - Primary Brand Colors
const NFL_TEAM_COLORS: Record<string, string> = {
  'ARI': '#97233F',  // Arizona Cardinals - Red
  'ATL': '#A71930',  // Atlanta Falcons - Red
  'BAL': '#241773',  // Baltimore Ravens - Purple
  'BUF': '#00338D',  // Buffalo Bills - Blue
  'CAR': '#0085CA',  // Carolina Panthers - Carolina Blue
  'CHI': '#0B162A',  // Chicago Bears - Dark Navy
  'CIN': '#FB4F14',  // Cincinnati Bengals - Orange
  'CLE': '#311D00',  // Cleveland Browns - Dark Brown
  'DAL': '#003594',  // Dallas Cowboys - Royal Blue
  'DEN': '#FB4F14',  // Denver Broncos - Orange
  'DET': '#0076B6',  // Detroit Lions - Honolulu Blue
  'GB': '#203731',   // Green Bay Packers - Dark Green
  'HOU': '#03202F',  // Houston Texans - Deep Steel Blue
  'IND': '#002C5F',  // Indianapolis Colts - Speed Blue
  'JAX': '#006778',  // Jacksonville Jaguars - Teal
  'KC': '#E31837',   // Kansas City Chiefs - Red
  'LAC': '#0080C6',  // Los Angeles Chargers - Powder Blue
  'LA': '#003594',   // Los Angeles Rams - Blue (database uses LA)
  'LAR': '#003594',  // Los Angeles Rams - Blue (alternative)
  'MIA': '#008E97',  // Miami Dolphins - Aqua
  'MIN': '#4F2683',  // Minnesota Vikings - Purple
  'NE': '#002244',   // New England Patriots - Nautical Blue
  'NO': '#D3BC8D',   // New Orleans Saints - Old Gold
  'NYG': '#0B2265',  // New York Giants - Dark Blue
  'NYJ': '#125740',  // New York Jets - Gotham Green
  'LV': '#A5ACAF',   // Las Vegas Raiders - Silver
  'PHI': '#004C54',  // Philadelphia Eagles - Midnight Green
  'PIT': '#FFB612',  // Pittsburgh Steelers - Gold
  'SF': '#AA0000',   // San Francisco 49ers - Red
  'SEA': '#002244',  // Seattle Seahawks - College Navy
  'TB': '#D50A0A',   // Tampa Bay Buccaneers - Red
  'TEN': '#0C2340',  // Tennessee Titans - Navy
  'WAS': '#5A1414',  // Washington Commanders - Burgundy
};

// NHL Team Colors - Primary Brand Colors
const NHL_TEAM_COLORS: Record<string, string> = {
  'ANA': '#F47A38',  // Anaheim Ducks - Orange
  'ARI': '#8C2633',  // Arizona Coyotes - Brick Red
  'BOS': '#FFB81C',  // Boston Bruins - Gold
  'BUF': '#003087',  // Buffalo Sabres - Royal Blue
  'CGY': '#D2001C',  // Calgary Flames - Red
  'CAL': '#D2001C',  // Calgary Flames - Red (alternative)
  'CAR': '#CE1126',  // Carolina Hurricanes - Red
  'CHI': '#CF0A2C',  // Chicago Blackhawks - Red
  'COL': '#6F263D',  // Colorado Avalanche - Burgundy
  'CBJ': '#002654',  // Columbus Blue Jackets - Union Blue
  'DAL': '#006847',  // Dallas Stars - Victory Green
  'DET': '#CE1126',  // Detroit Red Wings - Red
  'EDM': '#041E42',  // Edmonton Oilers - Blue
  'FLA': '#041E42',  // Florida Panthers - Navy
  'LAK': '#A2AAAD',  // Los Angeles Kings - Silver
  'LAS': '#B4975A',  // Vegas Golden Knights - Gold (database uses LAS)
  'VGK': '#B4975A',  // Vegas Golden Knights - Gold (alternative)
  'MIN': '#154734',  // Minnesota Wild - Forest Green
  'MTL': '#AF1E2D',  // Montreal Canadiens - Red
  'MON': '#AF1E2D',  // Montreal Canadiens - Red (alternative)
  'NSH': '#FFB81C',  // Nashville Predators - Gold
  'NJD': '#CE1126',  // New Jersey Devils - Red
  'NYI': '#00539B',  // New York Islanders - Blue
  'NYR': '#0038A8',  // New York Rangers - Blue
  'OTT': '#DA1A32',  // Ottawa Senators - Red
  'PHI': '#F74902',  // Philadelphia Flyers - Orange
  'PIT': '#CFC493',  // Pittsburgh Penguins - Gold
  'STL': '#002F87',  // St. Louis Blues - Blue
  'SJS': '#006D75',  // San Jose Sharks - Teal
  'SEA': '#001628',  // Seattle Kraken - Deep Sea Blue
  'TBL': '#002868',  // Tampa Bay Lightning - Blue
  'TOR': '#00205B',  // Toronto Maple Leafs - Blue
  'VAN': '#00205B',  // Vancouver Canucks - Blue
  'WSH': '#041E42',  // Washington Capitals - Navy
  'WPG': '#041E42',  // Winnipeg Jets - Navy
};

// NBA Team Colors - Primary Brand Colors
const NBA_TEAM_COLORS: Record<string, string> = {
  'ATL': '#C8102E',  // Atlanta Hawks - Torch Red
  'BOS': '#007A33',  // Boston Celtics - Celtics Green
  'BKN': '#000000',  // Brooklyn Nets - Black
  'CHA': '#1D1160',  // Charlotte Hornets - Purple
  'CHI': '#CE1141',  // Chicago Bulls - Bulls Red
  'CLE': '#860038',  // Cleveland Cavaliers - Wine
  'DAL': '#00538C',  // Dallas Mavericks - Royal Blue
  'DEN': '#0E2240',  // Denver Nuggets - Midnight Blue
  'DET': '#C8102E',  // Detroit Pistons - Red
  'GSW': '#1D428A',  // Golden State Warriors - Blue
  'HOU': '#CE1141',  // Houston Rockets - Red
  'IND': '#002D62',  // Indiana Pacers - Blue
  'LAC': '#C8102E',  // Los Angeles Clippers - Red
  'LAL': '#552583',  // Los Angeles Lakers - Purple
  'MEM': '#5D76A9',  // Memphis Grizzlies - Blue
  'MIA': '#98002E',  // Miami Heat - Red
  'MIL': '#00471B',  // Milwaukee Bucks - Good Land Green
  'MIN': '#0C2340',  // Minnesota Timberwolves - Midnight Blue
  'NOP': '#0C2340',  // New Orleans Pelicans - Navy
  'NYK': '#006BB6',  // New York Knicks - Blue
  'OKC': '#007AC1',  // Oklahoma City Thunder - Blue
  'ORL': '#0077C0',  // Orlando Magic - Blue
  'PHI': '#006BB6',  // Philadelphia 76ers - Blue
  'PHX': '#1D1160',  // Phoenix Suns - Purple
  'PHO': '#1D1160',  // Phoenix Suns - Purple (alternative abbreviation)
  'POR': '#E03A3E',  // Portland Trail Blazers - Red
  'SAC': '#5A2D81',  // Sacramento Kings - Purple
  'SAS': '#C4CED4',  // San Antonio Spurs - Silver
  'TOR': '#CE1141',  // Toronto Raptors - Red
  'UTA': '#002B5C',  // Utah Jazz - Navy
  'WAS': '#002B5C',  // Washington Wizards - Navy Blue
};

// MLB Team Colors - Primary Brand Colors
const MLB_TEAM_COLORS: Record<string, string> = {
  'ARI': '#A71930',  // Arizona Diamondbacks - Sedona Red
  'ATL': '#13274F',  // Atlanta Braves - Navy
  'BAL': '#DF4601',  // Baltimore Orioles - Orange
  'BOS': '#BD3039',  // Boston Red Sox - Red
  'CHC': '#0E3386',  // Chicago Cubs - Blue
  'CHW': '#27251F',  // Chicago White Sox - Black
  'CIN': '#C6011F',  // Cincinnati Reds - Red
  'CLE': '#00385D',  // Cleveland Guardians - Navy Blue
  'COL': '#333366',  // Colorado Rockies - Purple
  'DET': '#FA4616',  // Detroit Tigers - Orange
  'HOU': '#002D62',  // Houston Astros - Navy
  'KC': '#004687',   // Kansas City Royals - Royal Blue
  'LAA': '#003263',  // Los Angeles Angels - Midnight Blue
  'LAD': '#005A9C',  // Los Angeles Dodgers - Dodger Blue
  'MIA': '#00A3E0',  // Miami Marlins - Miami Blue
  'MIL': '#0046AE',  // Milwaukee Brewers - Blue
  'MIN': '#002B5C',  // Minnesota Twins - Twins Navy
  'NYM': '#002D72',  // New York Mets - Blue
  'NYY': '#0C2340',  // New York Yankees - Uniform Navy
  'OAK': '#003831',  // Oakland Athletics - Green
  'PHI': '#E81828',  // Philadelphia Phillies - Red
  'PIT': '#FDB827',  // Pittsburgh Pirates - Gold
  'STL': '#C41E3A',  // St. Louis Cardinals - Cardinal Red
  'SD': '#2F241D',   // San Diego Padres - Brown
  'SF': '#FD5A1E',   // San Francisco Giants - Orange
  'SEA': '#005C5C',  // Seattle Mariners - Northwest Green
  'TB': '#092C5C',   // Tampa Bay Rays - Navy Blue
  'TEX': '#003278',  // Texas Rangers - Blue
  'TOR': '#006BA6',  // Toronto Blue Jays - Light Blue
  'WSH': '#AB0003',  // Washington Nationals - Red
};

// EPL Team Colors - Primary Brand Colors
const EPL_TEAM_COLORS: Record<string, string> = {
  'ARS': '#EF0107',  // Arsenal - Red
  'AST': '#95BFE5',  // Aston Villa - Blue
  'BOU': '#DA291C',  // Bournemouth - Red
  'BRE': '#D71920',  // Brentford - Red (using Southampton colors as fallback)
  'BRI': '#0057B8',  // Brighton - Blue
  'BUR': '#6C1D45',  // Burnley - Burgundy
  'CHE': '#034694',  // Chelsea - Blue
  'CRY': '#1B458F',  // Crystal Palace - Blue
  'EVE': '#003399',  // Everton - Blue
  'FUL': '#000000',  // Fulham - Black
  'LEE': '#FFF200',  // Leeds United - Yellow (using Norwich colors)
  'LEI': '#003090',  // Leicester City - Blue
  'LIV': '#C8102E',  // Liverpool - Red
  'MAC': '#6CABDD',  // Manchester City - Sky Blue
  'MUN': '#DA291C',  // Manchester United - Red
  'NEW': '#241F20',  // Newcastle - Black
  'NOT': '#DA291C',  // Nottingham Forest - Red (using Bournemouth red)
  'SUN': '#DA291C',  // Sunderland - Red (using Bournemouth red)
  'TOT': '#132257',  // Tottenham - Navy Blue
  'WES': '#7A263A',  // West Ham - Maroon
  'WOL': '#FDB913',  // Wolves - Yellow
};

// La Liga Team Colors - Primary Brand Colors
const LA_LIGA_TEAM_COLORS: Record<string, string> = {
  'ALA': '#009AD7',  // Deportivo Alavés - Light Blue
  'ATH': '#EE2523',  // Athletic Bilbao - Red
  'ATM': '#272E61',  // Atletico Madrid - Navy Blue
  'BAR': '#A50044',  // Barcelona FC - Burgundy
  'CEL': '#8AC3EE',  // RC Celta de Vigo - Blue
  'EIB': '#AA093C',  // SD Eibar - Dark Red
  'ESP': '#007FC8',  // RCD Espanyol - Blue
  'GET': '#005999',  // Getafe CF - Blue
  'GRA': '#A61B2B',  // Granada CF - Red
  'LEG': '#0C1F6E',  // CD Leganes - Blue
  'LEV': '#B4053F',  // Levante Union Deportiva - Maroon
  'MAL': '#E20613',  // RCD Mallorca - Red
  'BET': '#0BB363',  // Real Betis - Green
  'RMA': '#FEBE10',  // Real Madrid C.F. - Gold
  'RSO': '#0067B1',  // Real Sociedad - Blue
  'SEV': '#F43333',  // Sevilla FC - Red
  'VLD': '#921B88',  // Valladolid - Violet
  'VAL': '#0097D7',  // Valencia C.F. - Blue
  'VIL': '#FFE667',  // Villarreal CF - Yellow
  'OSA': '#D91A21',  // Osasuna - Red
  'ELC': '#05642C',  // Elche CF - Green
  'RAY': '#E53027',  // Rayo Vallecano - Red
  'GIR': '#CD2534',  // Girona - Red
  // Additional abbreviations that might appear in slugs
  'OVI': '#009AD7',  // Real Oviedo (using Alavés colors as fallback)
  'MAD': '#272E61',  // Madrid (Atletico Madrid)
  'BIL': '#EE2523',  // Bilbao (Athletic Bilbao)
  'VIG': '#8AC3EE',  // Vigo (Celta de Vigo)
  'SOC': '#0067B1',  // Sociedad (Real Sociedad)
};

// Bundesliga Team Colors - Primary Brand Colors
const BUNDESLIGA_TEAM_COLORS: Record<string, string> = {
  // Primary team abbreviations (from event slugs)
  'HEI': '#E2001A',  // 1. FC Heidenheim - Red
  'KOE': '#ED1C24',  // 1. FC Köln - Red (corrected from KOL)
  'HOF': '#1961B5',  // 1899 Hoffenheim - Blue
  'B04': '#E32221',  // Bayer Leverkusen - Red (corrected from LEV)
  'BAY': '#DC052D',  // Bayern München - Red
  'DOR': '#FDE100',  // Borussia Dortmund - Yellow (corrected from BVB)
  'MOE': '#000000',  // Borussia Mönchengladbach - Black (corrected from BMG)
  'EIN': '#E1000F',  // Eintracht Frankfurt - Red (corrected from SGE)
  'AUG': '#BA3733',  // FC Augsburg - Red (corrected from FCA)
  'PAU': '#EC1B24',  // FC St. Pauli - Red (corrected from STP)
  'MAI': '#C3141E',  // FSV Mainz 05 - Red
  'HSV': '#0A3F86',  // Hamburger SV - Blue
  'LEI': '#DD013F',  // RB Leipzig - Red (corrected from RBL)
  'FRE': '#000000',  // SC Freiburg - Black (corrected from SCF)
  'UNI': '#FDDC02',  // Union Berlin - Yellow
  'STU': '#E32219',  // VfB Stuttgart - Red (corrected from VFB)
  'WOL': '#65B32E',  // VfL Wolfsburg - Green (corrected from WOB)
  'WER': '#1D9053',  // Werder Bremen - Green (corrected from BRE)
  // Additional teams
  'BSC': '#004D9E',  // Hertha BSC - Blue
  'ARM': '#004E95',  // Arminia Bielefeld - Blue
  'BOC': '#005CA9',  // VfL Bochum - Blue
  'FUR': '#009932',  // SpVgg Greuther Fürth - Green
  // Alternative abbreviations
  'KOL': '#ED1C24',  // Köln (1. FC Köln) - alternative
  'LEV': '#E32221',  // Leverkusen (Bayer Leverkusen) - alternative
  'BVB': '#FDE100',  // Dortmund (Borussia Dortmund) - alternative
  'BMG': '#000000',  // Mönchengladbach (Borussia Mönchengladbach) - alternative
  'SGE': '#E1000F',  // Frankfurt (Eintracht Frankfurt) - alternative
  'FCA': '#BA3733',  // Augsburg (FC Augsburg) - alternative
  'STP': '#EC1B24',  // Pauli (FC St. Pauli) - alternative
  'RBL': '#DD013F',  // Leipzig (RB Leipzig) - alternative
  'SCF': '#000000',  // Freiburg (SC Freiburg) - alternative
  'VFB': '#E32219',  // Stuttgart (VfB Stuttgart) - alternative
  'WOB': '#65B32E',  // Wolfsburg (VfL Wolfsburg) - alternative
  'BRE': '#1D9053',  // Bremen (Werder Bremen) - alternative
  'MUN': '#DC052D',  // München (Bayern München) - alternative
  'BER': '#FDDC02',  // Berlin (Union Berlin) - alternative
  'FRA': '#E1000F',  // Frankfurt (Eintracht Frankfurt) - alternative
  'HAM': '#0A3F86',  // Hamburg (Hamburger SV) - alternative
  'MGL': '#000000',  // Mönchengladbach (Borussia Mönchengladbach) - alternative
  'BREM': '#1D9053',  // Bremen (Werder Bremen) - alternative
};

// CFB Team Colors - Primary Brand Colors
const CFB_TEAM_COLORS: Record<string, string> = {
  'ABCHR': '#006633', 'AIRF': '#414042', 'AKRON': '#005A9C', 'ALA': '#9E1B32',
  'ALAAM': '#FF8200', 'ALAST': '#FF8200', 'ALBNY': '#E4002B', 'ALCST': '#006633',
  'ALF': '#000000', 'APPLST': '#000000', 'ARK': '#9D2235', 'ARKST': '#BA0C2F',
  'ARMON': '#006633', 'ARMY': '#000000', 'ARPB': '#006633', 'ARZ': '#002D72',
  'ARZST': '#8C1D40', 'AUBRN': '#024B2A', 'AUSP': '#CC0000', 'BALLST': '#CE9B2E',
  'BAYL': '#500000', 'BCOOK': '#006633', 'BOISE': '#0033A0', 'BOSCOL': '#921A31',
  'BOWLGR': '#FF0000', 'BRYANT': '#000000', 'BUCK': '#000000', 'BUF': '#003E7E',
  'BYU': '#004B98', 'CAH': '#FDB827', 'CALPOL': '#660000', 'CAMP': '#006633',
  'CARK': '#006633', 'CATA': '#000000', 'CENCON': '#006633', 'CHARLT': '#492C92',
  'CHAT': '#000000', 'CHDE': '#000000', 'CHSOU': '#006633', 'CIN': '#E00122',
  'CITA': '#000000', 'CLMSN': '#F56600', 'CMICH': '#CF1020', 'COAST': '#006633',
  'COL': '#000000', 'COLG': '#000000', 'COLST': '#1D3F91', 'DEL': '#0039A6',
  'DELST': '#006633', 'DRAKE': '#000000', 'DUKE': '#001A57', 'DUQ': '#0033A0',
  'DXST': '#000000', 'ECAR': '#440A5A', 'EILL': '#006633', 'EKENT': '#006633',
  'ELON': '#006633', 'EMICH': '#003366', 'ENM': '#006633', 'ETNST': '#006633',
  'EWASH': '#006633', 'FAIRS': '#000000', 'FL': '#FA4616', 'FLAM': '#006633',
  'FLATL': '#003A6B', 'FLINT': '#006633', 'FLST': '#CEB888', 'FORDM': '#003E7D',
  'FREST': '#C41230', 'FURMAN': '#000000', 'GA': '#BA0C2F', 'GARDWB': '#006633',
  'GAS': '#006633', 'GAST': '#003A6B', 'GRMBST': '#006633', 'GTECH': '#9D2235',
  'HAMP': '#006633', 'HAWAII': '#003A6B', 'HDSM': '#006633', 'HOFST': '#E66C38',
  'HOLY': '#000000', 'HOU': '#B81B1B', 'HOUBAP': '#006633', 'HOWRD': '#006633',
  'IDAHO': '#000000', 'IDHST': '#006633', 'ILL': '#13294B', 'ILLST': '#CC0000',
  'ILLWES': '#006633', 'INCAR': '#006633', 'IND': '#990000', 'INDST': '#006633',
  'IOWA': '#FF0000', 'IOWAST': '#C8102E', 'JAC': '#006633', 'JACKST': '#006633',
  'JAXST': '#006633', 'JMAD': '#0099CC', 'KAN': '#E8000D', 'KANST': '#512888',
  'KENEST': '#006633', 'KENTST': '#000000', 'LAFAY': '#000000', 'LAKE': '#000000',
  'LAMAR': '#006633', 'LAMON': '#006633', 'LBB': '#000000', 'LCHB': '#000000',
  'LEHI': '#006633', 'LIBRTY': '#000000', 'LIUB': '#006633', 'LOAKS': '#000000',
  'LOU': '#AD0000', 'LOULAF': '#EAA72E', 'LOUTCH': '#CC0000', 'LSU': '#461D7C',
  'MAINE': '#006633', 'MARSH': '#006633', 'MARY': '#E03A3E', 'MCNST': '#006633',
  'MERC': '#006633', 'MERRI': '#006633', 'MIA': '#F47321', 'MIAOH': '#C41230',
  'MICH': '#00274D', 'MINNST': '#FF0000', 'MISS': '#9D2235', 'MISSR': '#000000',
  'MONM': '#006633', 'MONST': '#006633', 'MONT': '#006633', 'MORGST': '#006633',
  'MPHS': '#006633', 'MSPST': '#660000', 'MSRST': '#006633', 'MST': '#18453B',
  'MSVLST': '#006633', 'MTNST': '#003A6B', 'MURST': '#006633', 'NAL': '#006633',
  'NARZ': '#006633', 'NAVY': '#00205B', 'NCAR': '#7BAFD4', 'NCAT': '#006633',
  'NCC': '#006633', 'NCOL': '#006633', 'NCST': '#CC0000', 'NCW': '#006633',
  'ND': '#000000', 'NDAK': '#006633', 'NDKST': '#006633', 'NEAST': '#006633',
  'NEBR': '#E41C39', 'NEVADA': '#003366', 'NHAMP': '#006633', 'NICHLS': '#006633',
  'NILL': '#006633', 'NIOWA': '#006633', 'NMH': '#006633', 'NMX': '#C0C0C0',
  'NMXST': '#CC0000', 'NOPA': '#006633', 'NORFST': '#006633', 'NTX': '#006633',
  'NW': '#000000', 'NWOST': '#000000', 'NWST': '#006633', 'OBB': '#006633',
  'OHIO': '#006633', 'OHIOST': '#BB0000', 'OKL': '#841617', 'OKST': '#FF8200',
  'OLD': '#006633', 'ORE': '#006633', 'OREGST': '#8B0000', 'PENNST': '#000000',
  'PITT': '#003594', 'PORTST': '#006633', 'PRESB': '#006633', 'PRNCE': '#000000',
  'PUR': '#000000', 'PVAM': '#006633', 'RI': '#000000', 'RICE': '#000000',
  'RICH': '#E8000D', 'ROBMS': '#006633', 'RUTGER': '#CC0035', 'SACRED': '#006633',
  'SACST': '#006633', 'SALA': '#006633', 'SAMF': '#006633', 'SAVST': '#006633',
  'SC': '#000000', 'SCARST': '#006633', 'SDAK': '#006633', 'SDKST': '#006633',
  'SDST': '#C41230', 'SELOU': '#006633', 'SEMST': '#006633', 'SFAUS': '#006633',
  'SFL': '#003A6B', 'SILL': '#006633', 'SJST': '#003366', 'SMHO': '#006633',
  'SMU': '#CC0000', 'SOUMIS': '#006633', 'SOUTH': '#006633', 'SRU': '#000000',
  'STAN': '#8C1515', 'STBR': '#006633', 'STFPA': '#006633', 'STMN': '#000000',
  'SUTAH': '#006633', 'SYRA': '#D44500', 'TARL': '#006633', 'TCU': '#632689',
  'TEMPL': '#003E7D', 'TENN': '#000000', 'TENST': '#006633', 'TENTCH': '#006633',
  'TMRT': '#0E4F2F', 'TOLEDO': '#CC0000', 'TOWS': '#000000', 'TROY': '#CC0000',
  'TULANE': '#006633', 'TULSA': '#066F48', 'TUSC': '#000000', 'TUSK': '#006633',
  'TX': '#BF5700', 'TXAM': '#500000', 'TXAMC': '#006633', 'TXS': '#006633',
  'TXST': '#006633', 'TXTECH': '#CC0000', 'UAB': '#006633', 'UCDV': '#003262',
  'UCF': '#006633', 'UCLA': '#2774AE', 'UCONN': '#003A8C', 'UK': '#0033A0',
  'UMASS': '#003366', 'UNLV': '#CF1020', 'USC': '#990000', 'UTAH': '#CC0000',
  'UTAHST': '#002E5D', 'UTEP': '#FF8200', 'UTSA': '#15141A', 'UWG': '#006633',
  'VALP': '#000080', 'VAMIL': '#990000', 'VAND': '#8C1515', 'VILL': '#0033A0',
  'VIR': '#232D4B', 'VTECH': '#8C1515', 'WAG': '#003087', 'WAKE': '#000000',
  'WASH': '#361373', 'WASHST': '#5C3B9B', 'WCAR': '#A6192E', 'WEBST': '#000000',
  'WILL': '#000000', 'WILM': '#000000', 'WISC': '#C50536', 'WKENT': '#FF0000',
  'WM': '#3F4D6B', 'WMICH': '#C39953', 'WNM': '#000000', 'WOFF': '#000000',
  'WVIR': '#002855', 'WYOM': '#492F24', 'YALE': '#00356B', 'YNGST': '#CC0000',
};

// Serie A Team Colors - Primary Brand Colors
const SERIE_A_TEAM_COLORS: Record<string, string> = {
  'MIL': '#FB090B',  // A.C. Milan - Red
  'ROM': '#8E1F2F',  // A.S. Roma - Rosso Roma
  'ATA': '#1E71B8',  // Atalanta Bergamo - Blue
  'BOL': '#1A2F48',  // Bologna FC - Navy Blue
  'BRE': '#005CA8',  // Brescia - Blue
  'CAG': '#002350',  // Cagliari Calcio - Navy Blue
  'FIO': '#482E92',  // AC Fiorentina - Violet (Purple)
  'GEN': '#AD1919',  // Genoa - Red
  'VER': '#005395',  // Hellas Verona - Blue
  'INT': '#010E80',  // Inter Milan - Blue
  'JUV': '#000000',  // Juventus FC - Black
  'LAZ': '#87D8F7',  // Lazio - Sky Blue
  'LEC': '#ED1B23',  // Lecce - Red
  'NAP': '#12A0D7',  // Napoli - Light Blue
  'PAR': '#1B4094',  // Parma - Blue
  'SAM': '#1B5497',  // Sampdoria - Blue
  'SAS': '#00A752',  // Sassuolo - Green
  'SPA': '#3697C4',  // SPAL - Blue
  'TOR': '#8A1E03',  // Torino - Red
  'UDI': '#8B7D37',  // Udinese - Gold
  'COM': '#0038A8',  // Como - Royal Blue
  'PIS': '#041E42',  // Pisa SC - Nerazzurro (Blue)
  'CRE': '#C41E3A',  // US Cremonese - Grigiorosso (Red)
};

// Ligue 1 Team Colors - Primary Brand Colors
const LIGUE1_TEAM_COLORS: Record<string, string> = {
  'ANG': '#D9C395',  // Angers SCO - Gold
  'BOR': '#001B50',  // FC Girondins de Bordeaux - Navy Blue
  'SBR': '#ED1C24',  // Stade Brestois 29 - Red
  'CLE': '#C50C46',  // Clermont Foot - Red
  'RCL': '#EC1C24',  // RC Lens - Red
  'LIL': '#E01E13',  // Lille OSC - Red
  'LOR': '#F58113',  // FC Lorient - Orange
  'LYO': '#14387F',  // Lyon - Blue
  'OLM': '#2FAEE0',  // Olympique de Marseille - Blue
  'MET': '#6E0F12',  // FC Metz - Red
  'ASM': '#E51B22',  // AS Monaco - Red
  'MON': '#D87043',  // Montpellier Hérault SC - Orange
  'NAN': '#FCD405',  // FC Nantes - Yellow
  'NIC': '#000000',  // OGC Nice - Black
  'PSG': '#004170',  // Paris Saint-Germain F.C. - Blue
  'REI': '#EE2223',  // Stade de Reims - Red
  'REN': '#E13327',  // Stade Rennais - Red
  'STE': '#008D3F',  // AS Saint-Étienne - Green
  'STR': '#009FE3',  // RC Strasbourg Alsace - Blue
  'TRO': '#006EB2',  // ES Troyes AC - Blue
  'AJA': '#003087',  // AJ Auxerre - Blue
  'HAC': '#005B7F',  // Le Havre AC - Blue
  'PFC': '#00A1D6',  // Paris FC - Sky Blue
  'TOU': '#4B0082',  // Toulouse FC - Purple
};

// MLS Team Colors - Primary Brand Colors
const MLS_TEAM_COLORS: Record<string, string> = {
  'ATL': '#80000A',  // Atlanta United FC - Dark Red
  'AUS': '#00B140',  // Austin F.C. - Bright Verde (Green)
  'CHI': '#FF0000',  // Chicago Fire - Fire Red
  'CIN': '#F05323',  // FC Cincinnati - Orange
  'COL': '#960A2C',  // Colorado Rapids - Burgundy
  'CLB': '#FEDD00',  // Columbus Crew - Yellow
  'DCU': '#EF3E42',  // D.C. United - Red
  'DAL': '#E81F3E',  // FC Dallas - Republic Red
  'HOU': '#101820',  // Houston Dynamo - Raven Black
  'MIA': '#F7B5CD',  // Inter Miami CF - Pink
  'LAG': '#00245D',  // LA Galaxy - Navy Blue
  'LAF': '#C39E6D',  // Los Angeles FC - California Gold
  'MIN': '#8CD2F4',  // Minnesota United - Sky Blue
  'MTL': '#0033A1',  // CF Montréal - Sacré Bleu
  'NER': '#CE0E2D',  // New England Revolution - Red
  'NYC': '#6CACE4',  // New York City FC - Sky Blue
  'NYR': '#23326A',  // New York Red Bulls - Blue
  'ORL': '#633492',  // Orlando City SC - Purple
  'PHI': '#B19B69',  // Philadelphia Union - Gold
  'POR': '#00482B',  // Portland Timbers - Green
  'RSL': '#B30838',  // Real Salt Lake - Claret Red
  'SJE': '#000000',  // San Jose Earthquakes - Black
  'SEA': '#5D9741',  // Seattle Sounders FC - Rave Green
  'SKC': '#91B0D5',  // Sporting Kansas City - Sporting Blue
  'TOR': '#B81137',  // Toronto FC - Red
  'VWH': '#00245E',  // Vancouver Whitecaps FC - Deep Sea Blue
};

// FIFA Friendlies National Team Colors - Primary Flag/Jersey Colors
const FIFA_FRIENDLIES_TEAM_COLORS: Record<string, string> = {
  'ARG': '#43A1D5',  // Argentina - Light Blue
  'AUS': '#009A49',  // Australia - Green
  'BAH1': '#CE1126', // Bahrain - Red
  'BAH': '#CE1126',  // Bahrain - Red (alternative)
  'BOL': '#006633',  // Bolivia - Green
  'BIH': '#0038A8',  // Bosnia and Herzegovina - Blue
  'BRA': '#FFDF00',  // Brazil - Yellow
  'CAN': '#C5281C',  // Canada - Red
  'CHL': '#D52B1E',  // Chile - Red
  'COL': '#FFCD00',  // Colombia - Yellow
  'CUB': '#CF142B',  // Cuba - Red
  'DOM': '#CE1126',  // Dominican Republic - Red
  'ECU': '#FFED4E',  // Ecuador - Yellow
  'ENG': '#C5281C',  // England - Red
  'GRN': '#009B3A',  // Grenada - Green
  'IRN': '#239F40',  // IR Iran - Green
  'JPN': '#002B7F',  // Japan - Blue
  'JOR': '#CE1126',  // Jordan - Red
  'KOR1': '#CD2E3A', // Korea Republic - Red
  'KOR': '#CD2E3A',  // Korea Republic - Red (alternative)
  'KUW': '#0038A8',  // Kuwait - Blue
  'MAL': '#CE1126',  // Malta - Red
  'MEX': '#009B3A',  // Mexico - Green
  'MOL': '#CE1126',  // Moldova - Red
  'MAR': '#17A376',  // Morocco - Green
  'NZL': '#C5281C',  // New Zealand - Red
  'PAR': '#CE1126',  // Paraguay - Red
  'PER': '#D91023',  // Peru - Red
  'POL': '#DC143C',  // Poland - Red
  'ROM': '#FFCD00',  // Romania - Yellow
  'RUS': '#CE1126',  // Russia - Red
  'USA': '#B31942',  // United States - Red
  'URY': '#4DA6DD',  // Uruguay - Light Blue
  'UZB': '#0038A8',  // Uzbekistan - Blue
  'VEN': '#4B0D1A',  // Venezuela - Maroon
  'WAL': '#C8102E',  // Wales - Red
};

const DEFAULT_TEAM_COLOR = '#667eea'; // Fallback color

export function getTeamColor(teamAbbr: string, leagueId?: string): string {
  const upperAbbr = teamAbbr.toUpperCase();
  
  // Determine sport from league_id (e.g., "NFL-2025", "NHL-2026", "NBA-2026", "MLB", "CFB-2025")
  const sport = leagueId?.split('-')[0]?.toUpperCase();
  
  if (sport === 'NHL') {
    return NHL_TEAM_COLORS[upperAbbr] || DEFAULT_TEAM_COLOR;
  } else if (sport === 'NFL') {
    return NFL_TEAM_COLORS[upperAbbr] || DEFAULT_TEAM_COLOR;
  } else if (sport === 'NBA') {
    return NBA_TEAM_COLORS[upperAbbr] || DEFAULT_TEAM_COLOR;
  } else if (sport === 'MLB') {
    return MLB_TEAM_COLORS[upperAbbr] || DEFAULT_TEAM_COLOR;
  } else if (sport === 'CFB') {
    return CFB_TEAM_COLORS[upperAbbr] || DEFAULT_TEAM_COLOR;
  } else if (sport === 'EPL') {
    return EPL_TEAM_COLORS[upperAbbr] || DEFAULT_TEAM_COLOR;
  } else if (sport === 'LA') {
    return LA_LIGA_TEAM_COLORS[upperAbbr] || DEFAULT_TEAM_COLOR;
  } else if (sport === 'BUNDESLIGA') {
    return BUNDESLIGA_TEAM_COLORS[upperAbbr] || DEFAULT_TEAM_COLOR;
  } else if (sport === 'SERIE') {
    return SERIE_A_TEAM_COLORS[upperAbbr] || DEFAULT_TEAM_COLOR;
  } else if (sport === 'LIGUE') {
    return LIGUE1_TEAM_COLORS[upperAbbr] || DEFAULT_TEAM_COLOR;
  } else if (sport === 'MLS') {
    return MLS_TEAM_COLORS[upperAbbr] || DEFAULT_TEAM_COLOR;
  } else if (sport === 'FIFA') {
    return FIFA_FRIENDLIES_TEAM_COLORS[upperAbbr] || DEFAULT_TEAM_COLOR;
  }

  // Fallback: try all color maps
  return NFL_TEAM_COLORS[upperAbbr] || NHL_TEAM_COLORS[upperAbbr] || NBA_TEAM_COLORS[upperAbbr] || MLB_TEAM_COLORS[upperAbbr] || CFB_TEAM_COLORS[upperAbbr] || EPL_TEAM_COLORS[upperAbbr] || LA_LIGA_TEAM_COLORS[upperAbbr] || BUNDESLIGA_TEAM_COLORS[upperAbbr] || SERIE_A_TEAM_COLORS[upperAbbr] || LIGUE1_TEAM_COLORS[upperAbbr] || MLS_TEAM_COLORS[upperAbbr] || FIFA_FRIENDLIES_TEAM_COLORS[upperAbbr] || DEFAULT_TEAM_COLOR;
}

export function extractTeamAbbreviations(slug: string): [string, string] {
  // Pattern: {sport}-{team1}-{team2}-{year}-{month}-{day}
  const parts = slug.split('-');
  if (parts.length < 3) return ['', ''];
  return [parts[1].toUpperCase(), parts[2].toUpperCase()];
}

// CFB abbreviation display mapping (frontend only - backend abbreviations unchanged)
const CFB_DISPLAY_ABBR_MAP: Record<string, string> = {
  'TULANE': 'TULN',
  'ALA': 'BAMA',
  'SFL': 'USF',
  'NTX': 'UNT',
  'FREST': 'FRES', 
  'COLST': 'CSU', 
  'RUTGER': 'RUTG',
  'FLST': 'FSU', 
  'MISSR': 'MIZ', 
  'CHARLT': 'CHAR', 
  'LOULAF': 'ULL', 
  'JMAD': 'JMU', 
  'OHIOST': 'OSU', 
  'MST': 'MSU', 
  'TOLEDO': 'TOL', 
  'BOWLGR': 'BGSU', 
  'MIAOH': 'M-OH', 
  'AKRON': 'AKR', 
  'WASHST': 'WASHU', 
  'NILL': 'NIU', 
  'EMICH': 'EMU', 
  'KENTST': 'KENT', 
  'BALLST': 'BALL', 
  'WMICH': 'WMU', 
  'NEBR': 'NEB', 
  'MARY': 'UMD', 
  'OREGST': 'ORST', 
  'PENNST': 'PSU', 
  'OKL': 'OU', 
  'VTECH': 'VT', 
  'GTECH': 'GT', 
  'KANST': 'KSU', 
  'IOWAST': 'ISU', 
  'COL': 'COLO', 
  'AIRF': 'AFA', 
  'APPLST': 'APP', 
  'GAST': 'GSU', 
  'OLD': 'ODU', 
  'MARSH': 'MRSH', 
  'TEMPL': 'TEM', 
  'FLATL': 'FAU', 
  'SJST': 'SJSU', 
  'WYOM': 'WYO', 
  'LAMON': 'ULM', 
  'COAST': 'CCAR', 
  'WISC': 'WIS', 
  'FL': 'UF', 
  'TXAM': 'TAMU', 
  'KAN': 'KU', 
  'TXTECH': 'TTU', 
  'GA': 'UGA', 
  'AUBRN': 'AUB', 
  'MINNST': 'MIN', 
  'CLMSN': 'CLEM', 
  'BOSCOL': 'BC', 
  'ARZ': 'ARIZ', 
  'NMX': 'UNM', 
  'BOISE': 'BSU', 
  'ARZST': 'ASU', 
  'SDST': 'SDSU', 
  'NEVADA': 'NEV', 
  'UTAHST': 'USU', 
  'HAWAII': 'HAW'
};

// Get display abbreviation (frontend-only transformation)
export function getDisplayAbbreviation(abbr: string, leagueId: string): string {
  const sport = leagueId?.split('-')[0]?.toUpperCase();

  if (sport === 'CFB') {
    return CFB_DISPLAY_ABBR_MAP[abbr] || abbr;
  }

  // Normalize NBA abbreviations (handle inconsistent API data)
  if (sport === 'NBA') {
    const NBA_ABBR_NORMALIZATION: Record<string, string> = {
      'PHO': 'PHX',  // Phoenix Suns alternative abbreviation
    };
    return NBA_ABBR_NORMALIZATION[abbr.toUpperCase()] || abbr;
  }

  return abbr;
}

// Get display team name (normalize abbreviations to full team names)
export function getDisplayTeamName(teamName: string, leagueId: string): string {
  const sport = leagueId?.split('-')[0]?.toUpperCase();

  // For NBA, convert abbreviations back to team names
  if (sport === 'NBA') {
    const NBA_ABBR_TO_NAME: Record<string, string> = {
      'PHO': 'Suns',
      'PHX': 'Suns',
      'BKN': 'Nets',
      'LAL': 'Lakers',
      // Add other mappings as needed
    };
    return NBA_ABBR_TO_NAME[teamName.toUpperCase()] || teamName;
  }

  return teamName;
}

// Helper function to match team name to abbreviation (league-aware to handle conflicts)
export function getTeamAbbreviationFromName(teamName: string, leagueId?: string): string {
  const upperName = teamName.toUpperCase();
  const sport = leagueId?.split('-')[0]?.toUpperCase();
  
  // NFL team mappings
  const NFL_NAME_MAP: Record<string, string> = {
    'CARDINALS': 'ARI', 'ARIZONA': 'ARI',
    'FALCONS': 'ATL', 'ATLANTA': 'ATL',
    'RAVENS': 'BAL', 'BALTIMORE': 'BAL',
    'BILLS': 'BUF', 'BUFFALO': 'BUF',
    'PANTHERS': 'CAR', 'CAROLINA': 'CAR',
    'BEARS': 'CHI', 'CHICAGO BEARS': 'CHI',
    'BENGALS': 'CIN', 'CINCINNATI': 'CIN',
    'BROWNS': 'CLE', 'CLEVELAND': 'CLE',
    'COWBOYS': 'DAL', 'DALLAS': 'DAL',
    'BRONCOS': 'DEN', 'DENVER': 'DEN',
    'LIONS': 'DET', 'DETROIT': 'DET',
    'PACKERS': 'GB', 'GREEN BAY': 'GB',
    'TEXANS': 'HOU', 'HOUSTON TEXANS': 'HOU',
    'COLTS': 'IND', 'INDIANAPOLIS': 'IND',
    'JAGUARS': 'JAX', 'JACKSONVILLE': 'JAX',
    'CHIEFS': 'KC', 'KANSAS CITY': 'KC',
    'CHARGERS': 'LAC', 'LA CHARGERS': 'LAC',
    'RAMS': 'LAR', 'LA RAMS': 'LAR',
    'DOLPHINS': 'MIA', 'MIAMI': 'MIA',
    'VIKINGS': 'MIN', 'MINNESOTA': 'MIN',
    'PATRIOTS': 'NE', 'NEW ENGLAND': 'NE',
    'SAINTS': 'NO', 'NEW ORLEANS': 'NO',
    'GIANTS': 'NYG', 'NY GIANTS': 'NYG',
    'JETS': 'NYJ', 'NY JETS': 'NYJ',
    'RAIDERS': 'LV', 'LAS VEGAS': 'LV',
    'EAGLES': 'PHI', 'PHILADELPHIA EAGLES': 'PHI',
    'STEELERS': 'PIT', 'PITTSBURGH': 'PIT',
    '49ERS': 'SF', 'SAN FRANCISCO': 'SF',
    'SEAHAWKS': 'SEA', 'SEATTLE': 'SEA',
    'BUCCANEERS': 'TB', 'TAMPA BAY': 'TB', 'BUCS': 'TB',
    'TITANS': 'TEN', 'TENNESSEE': 'TEN',
    'COMMANDERS': 'WAS', 'WASHINGTON': 'WAS',
  };
  
  // MLB team mappings
  const MLB_NAME_MAP: Record<string, string> = {
    'DIAMONDBACKS': 'ARI', 'D-BACKS': 'ARI',
    'BRAVES': 'ATL',
    'ORIOLES': 'BAL',
    'RED SOX': 'BOS',
    'CUBS': 'CHC', 'CHICAGO CUBS': 'CHC',
    'WHITE SOX': 'CHW', 'CHICAGO WHITE SOX': 'CHW',
    'REDS': 'CIN',
    'GUARDIANS': 'CLE',
    'ROCKIES': 'COL', 'COLORADO': 'COL',
    'TIGERS': 'DET',
    'ASTROS': 'HOU', 'HOUSTON ASTROS': 'HOU',
    'ROYALS': 'KC',
    'ANGELS': 'LAA', 'LA ANGELS': 'LAA',
    'DODGERS': 'LAD', 'LA DODGERS': 'LAD',
    'MARLINS': 'MIA',
    'BREWERS': 'MIL', 'MILWAUKEE': 'MIL',
    'TWINS': 'MIN',
    'METS': 'NYM', 'NY METS': 'NYM',
    'YANKEES': 'NYY', 'NY YANKEES': 'NYY',
    'ATHLETICS': 'OAK', 'A\'S': 'OAK',
    'PHILLIES': 'PHI',
    'PIRATES': 'PIT',
    'PADRES': 'SD', 'SAN DIEGO': 'SD',
    'GIANTS': 'SF', 'SF GIANTS': 'SF',
    'MARINERS': 'SEA',
    'RAYS': 'TB',
    'RANGERS': 'TEX', 'TEXAS RANGERS': 'TEX',
    'BLUE JAYS': 'TOR', 'TORONTO': 'TOR',
    'NATIONALS': 'WSH',
  };
  
  // NBA team mappings
  const NBA_NAME_MAP: Record<string, string> = {
    'HAWKS': 'ATL',
    'CELTICS': 'BOS', 'BOSTON': 'BOS',
    'NETS': 'BKN', 'BROOKLYN': 'BKN',
    'HORNETS': 'CHA', 'CHARLOTTE': 'CHA',
    'BULLS': 'CHI',
    'CAVALIERS': 'CLE', 'CAVS': 'CLE',
    'MAVERICKS': 'DAL', 'MAVS': 'DAL',
    'NUGGETS': 'DEN',
    'PISTONS': 'DET',
    'WARRIORS': 'GSW', 'GOLDEN STATE': 'GSW',
    'ROCKETS': 'HOU', 'HOUSTON ROCKETS': 'HOU',
    'PACERS': 'IND', 'INDIANA': 'IND',
    'CLIPPERS': 'LAC', 'LA CLIPPERS': 'LAC',
    'LAKERS': 'LAL', 'LA LAKERS': 'LAL',
    'GRIZZLIES': 'MEM', 'MEMPHIS': 'MEM',
    'HEAT': 'MIA',
    'BUCKS': 'MIL',
    'TIMBERWOLVES': 'MIN', 'T-WOLVES': 'MIN',
    'PELICANS': 'NOP', 'NEW ORLEANS PELICANS': 'NOP',
    'KNICKS': 'NYK', 'NY KNICKS': 'NYK',
    'THUNDER': 'OKC', 'OKLAHOMA CITY': 'OKC',
    'MAGIC': 'ORL', 'ORLANDO': 'ORL',
    '76ERS': 'PHI', 'SIXERS': 'PHI',
    'SUNS': 'PHX', 'PHOENIX': 'PHX', 'PHO': 'PHX',
    'TRAIL BLAZERS': 'POR', 'BLAZERS': 'POR',
    'KINGS': 'SAC', 'SACRAMENTO': 'SAC',
    'SPURS': 'SAS', 'SAN ANTONIO': 'SAS',
    'RAPTORS': 'TOR',
    'JAZZ': 'UTA', 'UTAH': 'UTA',
    'WIZARDS': 'WAS',
  };
  
  // NHL team mappings
  const NHL_NAME_MAP: Record<string, string> = {
    'DUCKS': 'ANA', 'ANAHEIM': 'ANA',
    'COYOTES': 'ARI',
    'BRUINS': 'BOS',
    'SABRES': 'BUF',
    'FLAMES': 'CAL', 'CALGARY': 'CAL',
    'HURRICANES': 'CAR',
    'BLACKHAWKS': 'CHI',
    'AVALANCHE': 'COL',
    'BLUE JACKETS': 'CBJ', 'COLUMBUS': 'CBJ',
    'STARS': 'DAL',
    'RED WINGS': 'DET',
    'OILERS': 'EDM', 'EDMONTON': 'EDM',
    'PANTHERS': 'FLA', 'FLORIDA': 'FLA',
    'KINGS': 'LAK', 'LA KINGS': 'LAK',
    'GOLDEN KNIGHTS': 'LAS', 'VEGAS': 'LAS',
    'WILD': 'MIN',
    'CANADIENS': 'MON', 'MONTREAL': 'MON', 'HABS': 'MON',
    'PREDATORS': 'NSH', 'NASHVILLE': 'NSH',
    'DEVILS': 'NJD', 'NEW JERSEY': 'NJD',
    'ISLANDERS': 'NYI', 'NY ISLANDERS': 'NYI',
    'RANGERS': 'NYR', 'NY RANGERS': 'NYR',
    'SENATORS': 'OTT', 'OTTAWA': 'OTT',
    'FLYERS': 'PHI',
    'PENGUINS': 'PIT',
    'BLUES': 'STL', 'ST. LOUIS': 'STL',
    'SHARKS': 'SJS', 'SAN JOSE': 'SJS',
    'KRAKEN': 'SEA',
    'LIGHTNING': 'TBL', 'TAMPA BAY LIGHTNING': 'TBL',
    'MAPLE LEAFS': 'TOR', 'LEAFS': 'TOR',
    'CANUCKS': 'VAN', 'VANCOUVER': 'VAN',
    'CAPITALS': 'WSH', 'CAPS': 'WSH',
    'JETS': 'WPG', 'WINNIPEG': 'WPG',
  };
  
  // Select the appropriate map based on sport
  let teamNameMap: Record<string, string> = {};
  if (sport === 'NFL') {
    teamNameMap = NFL_NAME_MAP;
  } else if (sport === 'MLB') {
    teamNameMap = MLB_NAME_MAP;
  } else if (sport === 'NBA') {
    teamNameMap = NBA_NAME_MAP;
  } else if (sport === 'NHL') {
    teamNameMap = NHL_NAME_MAP;
  } else if (sport === 'LA-LIGA') {
    // La Liga uses 3-way betting, no team name mapping needed
    teamNameMap = {};
  } else if (sport === 'BUNDESLIGA') {
    // Bundesliga uses 3-way betting, no team name mapping needed
    teamNameMap = {};
  } else {
    // If no sport specified, try all maps (NFL first, then MLB, NBA, NHL)
    teamNameMap = { ...NFL_NAME_MAP, ...MLB_NAME_MAP, ...NBA_NAME_MAP, ...NHL_NAME_MAP };
  }
  
  // Try direct match first
  if (teamNameMap[upperName]) {
    return teamNameMap[upperName];
  }
  
  // Try finding a partial match (team name contains a key)
  for (const [key, abbr] of Object.entries(teamNameMap)) {
    if (upperName.includes(key)) {
      return abbr;
    }
  }
  
  // If no match found, return empty string
  return '';
}

export function formatSportsVolume(volume: string): string {
  const num = parseFloat(volume);
  if (isNaN(num)) return '$0 Vol.';
  
  if (num < 1000) {
    return `$${Math.round(num)} Vol.`;
  } else if (num < 1000000) {
    return `$${(num / 1000).toFixed(2)}k Vol.`;
  } else {
    return `$${(num / 1000000).toFixed(2)}m Vol.`;
  }
}

export function formatGameTime(timestamp: string): string {
  const date = new Date(timestamp);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;
  const displayMinutes = minutes.toString().padStart(2, '0');
  
  return `${displayHours}:${displayMinutes} ${ampm}`;
}

export function isGameLive(eventOrTimestamp: SportsEvent | string): boolean {
  // If event object is passed with live field, use it directly
  if (typeof eventOrTimestamp === 'object' && 'live' in eventOrTimestamp) {
    return eventOrTimestamp.live || false;
  }

  // Fallback to timestamp calculation for backwards compatibility
  const timestamp = typeof eventOrTimestamp === 'string' ? eventOrTimestamp : eventOrTimestamp.game_start_time;
  const gameStart = new Date(timestamp);
  const now = new Date();
  const hoursSinceStart = (now.getTime() - gameStart.getTime()) / (1000 * 60 * 60);

  return hoursSinceStart > 0 && hoursSinceStart < 4;
}

export function formatGameDate(timestamp: string): string {
  const date = new Date(timestamp);
  const today = new Date();

  // Check if it's today
  if (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  ) {
    return 'Today';
  }

  // Format as "DayOfWeek, Month Day"
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    month: 'long',
    day: 'numeric'
  };
  return date.toLocaleDateString('en-US', options);
}

export function formatProbabilityAsCents(prob: number): string {
  const cents = Math.round(prob * 100);
  return `${cents}¢`;
}

export function groupEventsByDate(events: SportsEvent[]): Record<string, SportsEvent[]> {
  const grouped: Record<string, SportsEvent[]> = {};

  events.forEach(event => {
    const date = formatGameDate(event.game_start_time);
    if (!grouped[date]) {
      grouped[date] = [];
    }
    grouped[date].push(event);
  });

  // Split groups into live and upcoming games
  const finalGrouped: Record<string, SportsEvent[]> = {};
  Object.entries(grouped).forEach(([date, groupEvents]) => {
    const liveGames = groupEvents.filter(event => isGameLive(event));
    const upcomingGames = groupEvents.filter(event => !isGameLive(event));

    // Add live games to "Live" heading
    if (liveGames.length > 0) {
      if (!finalGrouped['Live']) {
        finalGrouped['Live'] = [];
      }
      finalGrouped['Live'].push(...liveGames);
    }

    // Add upcoming games to original date heading
    if (upcomingGames.length > 0) {
      finalGrouped[date] = upcomingGames;
    }
  });

  return finalGrouped;
}

export function getLeagueNameFromLeagueId(leagueId: string): string {
  const leagueMapping: { [key: string]: string } = {
    'NFL': 'NFL',
    'NBA': 'NBA', 
    'MLB': 'MLB',
    'NHL': 'NHL',
    'EPL': 'Premier League',
    'LA-LIGA': 'La Liga',
    'BUNDESLIGA': 'Bundesliga',
    'SERIE-A': 'Serie A',
    'LIGUE-1': 'Ligue 1',
    'MLS': 'MLS',
    'FIFA-FRIENDLIES': 'FIFA Friendlies',
    'CFB': 'College Football',
    'Cricket': 'Cricket',
    'Tennis': 'Tennis',
    'Boxing': 'Boxing',
    'UFC': 'UFC',
    'Golf': 'Golf',
    'Rugby': 'Rugby',
    'Formula 1': 'Formula 1',
    'Chess': 'Chess'
  };
  
  // Check if we have an exact match first
  if (leagueMapping[leagueId]) {
    return leagueMapping[leagueId];
  }
  
  // For compound league IDs like "NHL-2026-ALT", extract just the base league
  const baseLeague = leagueId.split('-')[0];
  if (leagueMapping[baseLeague]) {
    return leagueMapping[baseLeague];
  }
  
  // Fallback to the original leagueId if no mapping found
  return leagueId;
}

export function getLiveLeagueName(events: SportsEvent[]): string {
  const liveEvents = events.filter(event => isGameLive(event.game_start_time));
  
  if (liveEvents.length === 0) {
    return 'Live';
  }
  
  // Get the most common league from live events
  const leagueCounts: { [key: string]: number } = {};
  liveEvents.forEach(event => {
    const leagueName = getLeagueNameFromLeagueId(event.league_id);
    leagueCounts[leagueName] = (leagueCounts[leagueName] || 0) + 1;
  });
  
  // Find the league with the most events
  const mostCommonLeague = Object.entries(leagueCounts)
    .sort(([,a], [,b]) => b - a)[0];
  
  return mostCommonLeague ? mostCommonLeague[0] : 'Live';
}

export function groupLiveEventsByLeague(events: SportsEvent[]): Record<string, SportsEvent[]> {
  const liveEvents = events.filter(event => isGameLive(event.game_start_time));
  const grouped: Record<string, SportsEvent[]> = {};
  
  liveEvents.forEach(event => {
    const leagueName = getLeagueNameFromLeagueId(event.league_id);
    if (!grouped[leagueName]) {
      grouped[leagueName] = [];
    }
    grouped[leagueName].push(event);
  });
  
  return grouped;
}

export function groupEventsWithPinned(events: SportsEvent[], pinnedEventIds: Set<string>, selectedSubCategory: string): Record<string, SportsEvent[]> {
  const pinnedEvents = events.filter(event => pinnedEventIds.has(event.id));
  const unpinnedEvents = events.filter(event => !pinnedEventIds.has(event.id));
  
  const result: Record<string, SportsEvent[]> = {};
  
  // Add pinned events at the top if any exist
  if (pinnedEvents.length > 0) {
    result['Pinned'] = pinnedEvents;
  }
  
  // Add remaining events grouped by date or league
  if (selectedSubCategory === 'Live') {
    // For Live page: group by league
    const leagueGrouped = groupLiveEventsByLeague(unpinnedEvents);
    Object.entries(leagueGrouped).forEach(([league, leagueEvents]) => {
      result[league] = leagueEvents;
    });
  } else {
    // For other pages: group by date
    const dateGrouped = groupEventsByDate(unpinnedEvents);
    Object.entries(dateGrouped).forEach(([date, dateEvents]) => {
      result[date] = dateEvents;
    });
  }
  
  return result;
}

